var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('p',[_vm._v(" This inspection identifies issues with the availability and latency of Redis instances. ")]),_c('v-card',[_c('v-img',{attrs:{"eager":"","src":"/static/img/docs/coroot-ce/inspections/redis.png"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }